export enum BorderRadius {
  R0 = '0px',
  R2 = '2px',
  R4 = '4px',
  R6 = '6px',
  R8 = '8px',
  R10 = '10px',
  R12 = '12px',
  R14 = '14px',
  R16 = '16px',
  R18 = '18px',
  R20 = '20px',
  R24 = '24px',
  R32 = '32px',
  RFull = '9999px',
}
